export const UPDATE_DESTINATION = "UPDATE_DESTINATION" as const;
export const CLEAR_DESTINATION = "CLEAR_DESTINATION" as const;
export const UPDATE_DESTINATION_WITH_PREDICTION_ADDRESS = "UPDATE_DESTINATION_WITH_PREDICTION_ADDRESS" as const;
export const INVALID_DESTINATION_ADDRESS = "INVALID_DESTINATION_ADDRESS" as const;
export const ADD_GOOGLE_PLACE_ID_TO_DESTINATION = "ADD_GOOGLE_PLACE_ID_TO_DESTINATION" as const;

export const addGooglePlaceIdToDestination = (payload) =>
  ({ type: ADD_GOOGLE_PLACE_ID_TO_DESTINATION, payload } as const);
export const clearDestination = () => ({ type: CLEAR_DESTINATION } as const);
export const updateDestination = (payload) => ({ type: UPDATE_DESTINATION, payload } as const);
export const updateDestinationWithPredictionAddress = (payload) =>
  ({ type: UPDATE_DESTINATION_WITH_PREDICTION_ADDRESS, payload } as const);
